import { queryOptions } from '@tanstack/react-query';

import { userConfigApi } from './userConfig.api';

export const userConfigQueryKey = ['userConfig'] as const;

export const userConfigOptions = () =>
  queryOptions({
    queryKey: userConfigQueryKey,
    queryFn: userConfigApi.fetch,
    staleTime: Infinity,
    retry: false
  });
